import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import { connect } from 'react-redux';
import { DAILY_DEALS_ID } from '../../../../globals/helpers/campaign/campaign-ids';

import CampaignLink from '../link';

import './index.scss';

const styles = bemGenerator('themes', [
  'article',
  'article-text',
  'article-image',
  'article-date',
]);

const formatDates = (campaign, translationCode, timeZone) => {
  const start = new Date(parseInt(campaign.start, 10));
  const end = new Date(parseInt(campaign.end, 10));
  const locale = translationCode.replace('_', '-').toLowerCase();
  const localeOptions = { month: 'long', day: 'numeric', timeZone };
  const startDate = start.toLocaleString(locale, localeOptions);
  const endDate = end.toLocaleString(locale, localeOptions);
  return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
};

const ThemeListItem = ({ campaign, translation, timezone }) =>
  campaign ? (
    <li className="row" key={campaign.id}>
      <div className="column">
        <article className={`${styles.article}`}>
          <div className="row">
            <div className="column small-12 medium-4 large-4">
              <CampaignLink
                campaign={campaign}
                linkContent={
                  <img
                    src={campaign.media.images.featured}
                    alt={campaign.title.short}
                    className={styles['article-image']}
                  />
                }
              />
            </div>
            <div
              className={`${
                styles['article-text']
              } column small-12 medium-8 large-8`}
            >
              <CampaignLink
                campaign={campaign}
                linkContent={
                  <span>
                    <h3>{campaign.title.short}</h3>
                    <p>{campaign.description.short}</p>
                  </span>
                }
              />
              {campaign.id !== DAILY_DEALS_ID && (
                <p className={styles['article-date']}>
                  {formatDates(campaign, translation, timezone)}
                </p>
              )}
              <CampaignLink campaign={campaign} />
            </div>
          </div>
        </article>
      </div>
    </li>
  ) : null;

const { shape, string } = PropTypes;

ThemeListItem.propTypes = {
  campaign: shape({
    title: shape({
      short: string,
    }),
    description: shape({
      short: string,
    }),
  }).isRequired,
  translation: string.isRequired,
  timezone: string.isRequired,
};

export default connect(state => ({
  translation: state.areas.campaign.translation,
  timezone: state.areas.campaign.timezone,
}))(ThemeListItem);
